// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"4dee0cf9","640":"d400d2f5"}[chunkId] + ".chunk.css";
};